<template>
  <div>

    <CRow>
      <CCol lg="12">
        <h1 class="main-header" v-translate translate-context="event_template">
          Template List
        </h1>
        <CCard class="">
          <CCardHeader>
            <div class="card-header-actions">
              <router-link :to="{name: 'eventTemplate.new'}" v-if="hasPerm('admin.template.create')">
                <CButton block color="primary" v-translate translate-context="list.actions">Create</CButton>
              </router-link>
            </div>
          </CCardHeader>
          <CCardBody class="px-0">
            <CDataTable
                :hover="false"
                :bordered="true"
                :items="templates.results"
                :fields="fields"
                :column-filter="{external: true,lazy:true}"
                :column-filter-value="filters"
                :sorter="{external: true, resetable:true}"
                :loading="loading"
                :sorter-value="sorting"
                @update:column-filter-value="updateFilters"
                @update:sorter-value="updateSorting"
                class="custom-table custom-table--clean custom-table--has-filters"
            >
              <template #no-items-view>
                <div class="text-center">
                  <h5 v-translate>No items found</h5>
                </div>
              </template>
              <template #sorting-icon="{ state, classes }">
                <div :class="classes">
                  <CIcon name="cipCaretUp" size="lg" v-if="state === 'asc' || state === 0"></CIcon>
                  <CIcon name="cipCaretUp" size="lg" v-else></CIcon>
                </div>
              </template>
              <template #actions="{item}">
                <td class="text-right">
                  <CButton size="sm" variant="outline" color="primary" class="mr-2"
                           v-if="hasPerm('admin.template.update')"
                           @click="$router.push({name: 'eventTemplate.edit', params: {id: item.id}})"
                           v-translate translate-context="list.actions"
                  >
                    Edit
                  </CButton>
                  <CButton @click="onDelete(item.id)" size="sm" variant="outline" color="danger"
                           v-if="hasPerm('admin.template.delete')"
                           v-translate translate-context="list.actions"
                  >
                    Delete
                  </CButton>
                </td>
              </template>
              <template #under-table>
                <CPagination
                    v-show="templates.pagination.num_pages > 1"
                    :activePage="templates.pagination.page"
                    @update:activePage="updatePage"
                    :pages="templates.pagination.num_pages"
                />
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>


    </CRow>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'ListEventTemplate',

  data() {
    return {
      loading: true,
      fields: [
        {key: 'id', label: this.$pgettext('event_template.list','ID'), _style: 'width:100px;'},
        {key: 'name', label: this.$pgettext('event_template.list','Name')},
        {key: 'actions', label: this.$pgettext('event_template.list','Actions'), sorter: false, filter: false}
      ],
      pagination: {
        page_size: 20,
        page: 1,
      },
      sorting: {
        column: null,
        asc: false
      },
      filters: {},
    }
  },
  async mounted() {
    await this.fetchConfig({type:'admin'})
    await this.fetchList()
  },
  computed: {
    ...mapGetters('eventTemplate', [
      'templates',
    ]),
  },
  methods: {
    ...mapActions('eventTemplate', [
      'fetchTemplateList',
      'deleteTemplate'
    ]),
    ...mapActions('login', [
      'fetchConfig'
    ]),
    async fetchList() {
      this.loading = true
      await this.fetchTemplateList({
        filters: this.filters,
        pagination: this.pagination,
        sorting: this.sorting
      })
      this.pagination.page = this.templates.pagination.page
      this.loading = false
    },
    updateFilters(filters) {
      this.filters = filters
      this.pagination.page = 1
      this.fetchList()
    },
    updateSorting(sorting) {
      this.sorting = sorting
      this.fetchList()
    },
    updatePage(page) {
      this.pagination.page = page
      this.fetchList()
    },
    async onDelete(id) {
      // TODO: Trovare un componente per fare i confirm
      if (!confirm('Are you sure?')) {
        return
      }
      await this.deleteTemplate(id)
      await this.fetchList()
    }
  }
}
</script>

<style scoped>

</style>